export default "__VITE_ASSET__B5ideQs1__"